/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { LinearProgress } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  overlayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#ffffff',
    opacity: '0.4',
    zIndex: 1000,
  },
  progress: {
    zIndex: 1001,
  },
}));

const Overlay = ({ progress }) => {
  const classes = useStyles();

  return (
    <>
      <LinearProgress
        className={classes.progress}
        {...(!isNaN(progress) && { variant: 'determinate', value: progress })}
      />
      <div className={classes.overlayContainer}></div>
    </>
  );
};

export default Overlay;
